module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedThin.012d3f5.ttf";